import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Actions} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {SettingsService} from 'src/app/services/settings.service';
import {StorageService} from 'src/app/services/storage.service';
import {enumToArray} from 'src/app/shared/functions/functions';
import {
  createApprovalFlowMutation,
  updateApprovalFlowMutation
} from 'src/app/store/entities/instution-settings/approval-flow/approval-flow.actions';
import {
  ApprovalFlow,
  ApprovalFlowProcessTypeEnum
} from 'src/app/store/entities/instution-settings/approval-flow/approval-flow.model';
import {AppState} from 'src/app/store/reducers';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-add-approval-settings',
  templateUrl: './add-approval-settings.component.html',
  styleUrls: ['./add-approval-settings.component.scss']
})
export class AddApprovalSettingsComponent implements OnInit {

  title: string;
  approvalFlowForm: FormGroup;

  hide: boolean = true;
  selectedData: ApprovalFlow;
  approvalFlow: ApprovalFlow;

  from: 'INST' | 'POPSM' = 'INST';


  constructor(
    private store: Store<AppState>,
    @Inject(MAT_DIALOG_DATA) data,
    private dialogRef: MatDialogRef<AddApprovalSettingsComponent>,
    private fb: FormBuilder,
    private route: ActivatedRoute,
  ) {
    this.selectedData = data?.approvalFlow
    this.from = data?.from
  }


  ngOnInit(): void {

    console.log(this.route.snapshot)
    this.title = `${this.selectedData ? 'Update' : 'Add'} Approval Flow`

    this.approvalFlowForm = this.fb.group({
      flowTitle: [null, Validators.required],
      flowProcess: [null, Validators.required],
    });


    if (this.selectedData) {
      this.approvalFlowForm.patchValue({
        ...this.selectedData
      });
    }

  }


  closeModal(close: boolean): void {
    if (close) {
      this.dialogRef.close();
    }
  }

  submitForm(formValue: { flowTitle: string,flowProcess:string}) {
    this.selectedData ? this.store.dispatch(updateApprovalFlowMutation({
        flow: {
          ...formValue,
          flowUniqueId: this.selectedData.flowUniqueId
        }
      })) :
      this.store.dispatch(createApprovalFlowMutation({
        flow: formValue
      }))
    this.closeModal(true)

}
}
